export enum ScaleRequestMode {
  REQUEST = "Request",
  BROADCAST = "Broadcast"
}
